import React, { useState, useEffect } from 'react';
import { FireIcon, TrophyIcon } from '@heroicons/react/24/solid';

const StreakDisplay = ({ user }) => {
  const [showAnimation, setShowAnimation] = useState(false);
  const [currentStreak, setCurrentStreak] = useState(0);
  const [longestStreak, setLongestStreak] = useState(0);

  useEffect(() => {
    if (user) {
      const streak = user.current_streak || 0;
      const longest = user.longest_streak || 0;
      
      setCurrentStreak(streak);
      setLongestStreak(longest);
      
      // Animation disabled per user request
      // No bounce animation when page loads
    }
  }, [user]);

  // Don't show anything if no streak
  if (!user || (!currentStreak && !longestStreak)) {
    return null;
  }

  // Determine streak level and color
  const getStreakLevel = (streak) => {
    if (streak >= 30) return { level: 'legendary', color: 'purple', emoji: '🔥' };
    if (streak >= 14) return { level: 'blazing', color: 'orange', emoji: '🔥' };
    if (streak >= 7) return { level: 'hot', color: 'red', emoji: '🔥' };
    if (streak >= 3) return { level: 'warming up', color: 'yellow', emoji: '⚡' };
    return { level: 'getting started', color: 'blue', emoji: '✨' };
  };

  const streakInfo = getStreakLevel(currentStreak);

  // Color classes based on streak level
  const colorClasses = {
    purple: {
      bg: 'bg-purple-50',
      border: 'border-purple-300',
      text: 'text-purple-700',
      iconBg: 'bg-purple-100',
      iconColor: 'text-purple-600',
      glow: 'shadow-purple-200'
    },
    orange: {
      bg: 'bg-orange-50',
      border: 'border-orange-300',
      text: 'text-orange-700',
      iconBg: 'bg-orange-100',
      iconColor: 'text-orange-600',
      glow: 'shadow-orange-200'
    },
    red: {
      bg: 'bg-red-50',
      border: 'border-red-300',
      text: 'text-red-700',
      iconBg: 'bg-red-100',
      iconColor: 'text-red-600',
      glow: 'shadow-red-200'
    },
    yellow: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-300',
      text: 'text-yellow-700',
      iconBg: 'bg-yellow-100',
      iconColor: 'text-yellow-600',
      glow: 'shadow-yellow-200'
    },
    blue: {
      bg: 'bg-blue-50',
      border: 'border-blue-300',
      text: 'text-blue-700',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
      glow: 'shadow-blue-200'
    }
  };

  const colors = colorClasses[streakInfo.color];

  return (
    <div className="flex items-center space-x-3">
      {/* Current Streak Badge */}
      {currentStreak > 0 && (
        <div
          className={`
            relative flex items-center space-x-2 px-3 py-2 rounded-lg border-2 
            ${colors.bg} ${colors.border} ${colors.text} 
            transition-all duration-300
          `}
        >
          <div className={`${colors.iconBg} p-1 rounded-full`}>
            <FireIcon className={`h-5 w-5 ${colors.iconColor}`} />
          </div>
          <div className="flex flex-col">
            <span className="text-xs font-medium opacity-75">Streak</span>
            <span className="text-lg font-bold leading-none">
              {currentStreak} {currentStreak === 1 ? 'day' : 'days'}
            </span>
          </div>
        </div>
      )}

    </div>
  );
};

export default StreakDisplay;

